import styled from 'styled-components';

interface Props {
  half?: boolean;
  double?: boolean;
  height?: string;
}

export const Spacer = styled.div<Props>`
  display: block;
  // FIXME: use units from a design system when it's ready
  height: 1em;

  ${(props) => props.half && 'height: 0.5em'};
  ${(props) => props.double && 'height: 2em'};
  ${(props) => props.height && `height: ${props.height}`};

`;
